import {createRouter, createWebHistory} from 'vue-router'
import { useMainStore } from '../store'

import UserList from '@/views/administration/UserList.vue'
import UserDetail from '@/views/administration/UserDetail.vue'
import LocationList from '@/views/administration/LocationList.vue'
import DepartmentList from '@/views/administration/DepartmentList.vue'
import PositionList from '@/views/administration/PositionList.vue'
import JobLevelList from '@/views/administration/JobLevelList.vue'
import GroupList from '@/views/administration/GroupList.vue'
import GroupAdd from '@/views/administration/GroupAdd.vue'
import GroupEdit from '@/views/administration/GroupEdit.vue'
import GroupManageUsers from '@/views/administration/GroupManageUsers.vue'

import YearSettings from '@/views/vacation/YearSettings.vue'
import AbsenceTypes from '@/views/vacation/AbsenceTypes.vue'
import TeamManagement from '@/views/vacation/TeamManagement.vue'
import TeamRules from '@/views/vacation/TeamRules.vue'

import LogIn from '@/views/LogIn.vue'
import Forbidden from '@/views/Forbidden.vue';
import NotFound from '@/views/NotFound.vue';
import VacationCalendar from "@/views/vacation/VacationCalendar.vue";
import Holidays from "@/views/vacation/Holidays.vue";
import HelpManagement from "@/views/administration/HelpManagement.vue";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: VacationCalendar,
        meta: {requireLogin: true}
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        component: Forbidden,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/notfound',
        name: 'NotFound',
        component: NotFound,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/login',
        name: 'LogIn',
        component: LogIn
    },
    {
        path: '/users',
        name: 'UserList',
        component: UserList,
        meta: {
            requireLogin: true,
            // viewPermission: 'users.view_user_list'
        }
    },
    {
        path: '/users/:id',
        name: 'UserDetail',
        component: UserDetail,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/locations',
        name: 'LocationList',
        component: LocationList,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/departments',
        name: 'DepartmentList',
        component: DepartmentList,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/positions',
        name: 'PositionList',
        component: PositionList,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/job-levels',
        name: 'JobLevelList',
        component: JobLevelList,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/groups',
        name: 'GroupList',
        component: GroupList,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/groups/add',
        name: 'GroupAdd',
        component: GroupAdd,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/groups/:id',
        name: 'GroupEdit',
        component: GroupEdit,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/groups/:id/manage-users',
        name: 'GroupManageUsers',
        component: GroupManageUsers,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/year-settings/',
        name: 'YearSettings',
        component: YearSettings,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/absence-types/',
        name: 'AbsenceTypes',
        component: AbsenceTypes,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/my-team/',
        name: 'ManagedTeam',
        component: TeamManagement,
        meta: {
            requireLogin: true
        },
    },
    {
        path: '/rules/',
        name: 'TeamRules',
        component: TeamRules,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/vacation-calendar/',
        name: 'VacationCalendar',
        component: VacationCalendar,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/help/',
        name: 'HelpManagement',
        component: HelpManagement,
        meta: {
            requireLogin: true
        }
    },
    {
        path: '/holidays',
        name: 'Holidays',
        component: Holidays,
        meta: {
            requireLogin: true
        },
        props: (route) => ({
            query: {
                year_id: route.query.year_id || null,
            },
        }),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },


]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const store = useMainStore()
    if (to.matched.some(record => record.meta.requireLogin) && !store.isAuthenticated) {
        next('/login')
    } else {
        next()
    }
})


export default router